import { Post } from "~/types/asgard/Post";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { getPrimaryTaxonomy } from "~/lib/shared/getPrimaryTaxonomy";
import { getRouteFromPostType } from "~/lib/shared/getRouteFromPostType";
import { ContentItemWithImageProps } from "~/components/ContentItemWithImage";

export type ReadMoreItem = {
  key: string;
  itemProps: Pick<
    ContentItemWithImageProps,
    | "date"
    | "footer"
    | "imageSrc"
    | "imageAlt"
    | "kicker"
    | "kickerHref"
    | "headline"
    | "headlineHref"
  >;
};

export const apiToReadMorePosts = (postList: Post[]): ReadMoreItem[] =>
  postList.map((post) => ({
    key: post.id.toString(),
    itemProps: {
      imageSrc: post.media?.sizes?.full?.source_url ?? "",
      imageAlt: post.media?.alt_text ?? "",
      kicker: heDecodeOrDefault(getPrimaryTaxonomy(post.tags)?.name),
      kickerHref: heDecodeOrDefault(
        `/tags/${getPrimaryTaxonomy(post.tags)?.slug}`
      ),
      headline: heDecodeOrDefault(post.title.rendered),
      headlineHref: getRouteFromPostType(post.type, post.slug) ?? null,
      date: post.date_gmt,
    },
  }));
